import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import yup from 'yup'
import FormError from '@components/FormError'
import FormLoader from '@components/FormLoader'
import TextArea from '@components/Form/TextArea'
import Button from '@components/Button'
import { capi } from '@atheneum/api'

class DisapproveInvoiceModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      error: null
    }
  }

  handleExit = () => {
    this.props.modalStore.close()
  }

  handleSubmit = async (values, actions) => {
    const { invoiceStore, modalStore, growlStore, invoice } = this.props
    this.setState({ error: null })

    try {
      if (invoice) {
        growlStore.showSuccess('Checking invoice id ...')
        const capiInvoice = await capi.checkInvoice({
          invoiceId: invoice.id
        })

        if (capiInvoice) {
          await capi.updateInvoiceStatus({
            invoiceId: invoice.id,
            status: 'draft'
          })
        }
      }
      await invoiceStore.updateToDisapproveStatus(
        invoice,
        values.disapprovalReason
      )
      modalStore.close()
      invoiceStore.get(invoice.id)
    } catch (error) {
      actions.setSubmitting(false)
      this.setState({ error })
      growlStore.showError(error)
    }
  }

  render() {
    const { invoice } = this.props

    return (
      <Formik
        initialValues={{
          disapprovalReason: ''
        }}
        validationSchema={yup.object().shape({
          disapprovalReason: yup
            .string('Disapproval reason is required')
            .required('Disapproval reason is required')
        })}
        onSubmit={this.handleSubmit}
        render={form => (
          <Form onSubmit={form.handleSubmit}>
            <FormLoader loading={form.isSubmitting} />

            <h1 className='left-text'>Dissaprove invoice {invoice.name}</h1>

            <FormError error={this.state.error} />

            <div className='separator hr-separator' />

            <div className='modalWrapper__form'>
              <Field
                name='disapprovalReason'
                label='Reason'
                component={TextArea}
              />
            </div>

            <div className='separator hr-separator' />

            <div className='modalWrapper__buttonWrapper'>
              <Button disabled={form.isSubmitting} submit primary>
                Send
              </Button>
              <Button
                disabled={form.isSubmitting}
                secondary
                onClick={this.handleExit}
              >
                Cancel
              </Button>
            </div>
          </Form>
        )}
      />
    )
  }
}

DisapproveInvoiceModal.propTypes = {
  modalStore: PropTypes.object,
  invoiceStore: PropTypes.object,
  growlStore: PropTypes.object,
  invoice: PropTypes.object
}

DisapproveInvoiceModal.defaultProps = {
  hideButtons: true,
  showCloseIcon: true
}

export default inject(
  'invoiceStore',
  'modalStore',
  'growlStore'
)(observer(DisapproveInvoiceModal))
